import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../config/employeeApiConfig';
import { Resignation, UpdateResignation, DeleteResignation, FetchResignationById } from './resignationType';


export const createResignation = createAsyncThunk(
  'resignation/createResignation',
  async (data: Resignation, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.post('/resignation', data)
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create resignation');
    }
  }
);

export const Updateresignation = createAsyncThunk<any, { employeeId: number; data: any }, { rejectValue: string }>(
  'resignation/updateResignation',
  async ({ employeeId, data }: { employeeId: number; data: Partial<UpdateResignation> }, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.put(`/resignation/${employeeId}`, data)
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create resignation');
    }
  }
);


export const deleteResignation = createAsyncThunk(
  'resignation/delete',
  async (resignationId: number, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.delete(`/resignation/${resignationId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete resignation');
    }
  }
);

export const fetchResignationById = createAsyncThunk(
  'resignation/fetchById',
  async (ResignationId: number, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/resignation/${ResignationId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch resignation');
    }
  }
);
export const fetchEmployeeDetailsById = createAsyncThunk(
  'resignation/EmployeeDetailsById',
  async (Id: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/resignation/employeeBydetails/${Id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch resignation');
    }
  }
);

export const fetchAllResignations = createAsyncThunk(
  'resignation/fetchAllresignation',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/resignation');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch all resignation');
    }
  }
);
export const getAllHODsAndHr = createAsyncThunk(
  'employee/getHODs',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get("/employee/hodAndHr");
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchHierarchyResignationRequests = createAsyncThunk(
  "leave/fetchHierarchyResignationRequests",
  async ({ useRouteId, includeSelf = false }: { useRouteId: number; includeSelf?: boolean },
    { rejectWithValue }
  ) => {
    try {
      const response = await employeeServiceApiInstance.get(`/resignation/hierarchy/${useRouteId}?includeSelf=${includeSelf}`);
      console.log(response.data, 'action.ts resignation')
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message || "Server error");
    }
  }
);

export const updateResignationStatus = createAsyncThunk(
  "resignation/updateStatus",
  async (
    { resignationId, status, ModifiedBy }: { resignationId: number; status: string, ModifiedBy: number }, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.put("/resignation/update/status", { resignationId, status, ModifiedBy });
      return { resignationId, status, message: response.data?.message || "Resignation status updated successfully" };
    } catch (error: any) {
      console.error("Error updating resignation status:", error);
      return rejectWithValue(
        error.response?.data?.message || "Failed to update resignation status"
      );
    }
  }
);

export const resignationBySupervisorHierarchy = createAsyncThunk(
  'resignation/fetchByemployeeId',
  async (supervisorId: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/resignation/supervisor/${supervisorId}`);
      console.log(response.data.data,'data froom actin')
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch resignation');
    }
  }
);


